import data from '../../data/hub-cards.json';
import { Link, useLocation } from 'react-router-dom';

interface HubCardItem {
  label: string;
  summary: string;
  href: string;
}

interface HubCardGroup {
  heading: string;
  items: HubCardItem[];
}

type HubCardsData = Record<string, HubCardGroup>;

interface HubCardsProps {
  group: string;
}

export default function HubCards({ group }: HubCardsProps) {
    const { pathname } = useLocation();
  const isEn = pathname === '/en' || pathname.startsWith('/en/');
  if (isEn) return null;
const typedData = data as HubCardsData;
  const groupData = typedData[group];

  if (!groupData) {
    return null;
  }

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="mx-auto max-w-6xl px-5 sm:px-6 lg:px-8">
        <h2 className="mb-8 text-center font-serif text-2xl text-[#1a1a1a] md:mb-12 md:text-4xl">
          {groupData.heading}
        </h2>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {groupData.items.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="block rounded-lg border border-gray-200 bg-white p-6 transition-colors hover:border-[#917c50] hover:bg-amber-50"
            >
              <span className="block font-serif text-lg text-[#1a1a1a]">{item.label}</span>
              <p className="mt-2 text-sm leading-7 text-gray-600">{item.summary}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
